module.exports = __webpack_public_path__ + "static/media/documents_001.089254e5.svg";